import { Colors, Text, View } from 'react-native-ui-lib';
import { Pressable } from 'react-native';
import React from 'react';
import { MaterialIcons } from '@expo/vector-icons';
import { strings } from '../localization/localization.web';

// A small, generic shortcut into the Learn tab's course list -- not a courses recommendation
// (which course(s) to highlight for a given source/statement is a curation/product decision,
// left for a separate change; see SourceScreen.tsx's original PR description). Shared so the
// Source screen's teaser and the main Public Feed's teaser (FeedList.tsx) stay visually and
// behaviorally identical.
export function CoursesTeaser({
  navigation,
  testID = 'courses-teaser',
}: {
  navigation: any;
  testID?: string;
}): JSX.Element {
  return (
    <Pressable
      testID={testID}
      onPress={() => navigation.navigate('Learn')}
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        backgroundColor: Colors.tertiaryBG,
        borderRadius: 12,
        padding: 12,
        marginBottom: 12,
      }}
    >
      <MaterialIcons name="book" size={24} color={Colors.iconSecondary} />
      <View flex style={{ paddingHorizontal: 10 }}>
        <Text text70 style={{ color: Colors.textPrimary, fontWeight: 'bold' }}>
          {strings.explore_courses_teaser_title}
        </Text>
        <Text text80 textSecondary>
          {strings.explore_courses_teaser_subtitle}
        </Text>
      </View>
      <MaterialIcons name="chevron-right" size={20} color={Colors.iconSecondary} />
    </Pressable>
  );
}
